import { createAsyncThunk } from "@reduxjs/toolkit";
import asyncInstance from "config/AsyncInstance";
import apiInstance from "config/axiosInstance";
import { toast } from "react-toastify";

export const GetInsuranceList = createAsyncThunk(
  "eligibilityCheck/GetInsuranceList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await asyncInstance.get("insuranceList");
      return response.data; // only return useful data
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const GetAllGenderList = createAsyncThunk(
  "eligibilityCheck/GetAllGenderList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get("genderList");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const GetAllMaritalList = createAsyncThunk(
  "eligibilityCheck/GetAllMaritalList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get("maritalstsList");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const GetAllProfession = createAsyncThunk(
  "eligibilityCheck/GetAllProfession",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get("professionList");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const GetAllRelationShip = createAsyncThunk(
  "eligibilityCheck/GetAllRelationShip",
  async (_, { rejectWithValue }) => {
    try {
      const response = await asyncInstance.get("relationshipList");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const GetAllProcessPriority = createAsyncThunk(
  "eligibilityCheck/GetAllProcessPriority",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get("prcspriorityList");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const GetAllNationalityList = createAsyncThunk(
  "eligibilityCheck/GetAllNationalityList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get("nationalidtypeList");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const GetAllPurposeList = createAsyncThunk(
  "eligibilityCheck/GetAllPurposeList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get("eligbpurposeList");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
export const GetAllIdentifierType = createAsyncThunk(
  "eligibilityCheck/GetAllIdentifierType",
  async (_, { rejectWithValue }) => {
    try {
      const response = await asyncInstance.get("identifiertypeList");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const SubmitEligibilityCheck = createAsyncThunk(
  "eligibilityCheck/SubmitEligibilityCheck",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(
        "insurance/eligibilityCheck",
        body
      );
      return response.data;
    } catch (error) {
      toast.error(error.response?.data);
    }
  }
);

export const SearchPatientByID = createAsyncThunk(
  "eligibilityCheck/SearchPatientByID",
  async (body) => {
    try {
      const response = await apiInstance.post("insurance/patientSearch", body);
      return response.data;
    } catch (error) {
      // toast.error("Something went wrong");
    }
  }
);

export const GetAllDropDownData = createAsyncThunk(
  "eligibilityCheck/GetAllDropDownData",
  async () => {
    try {
      const response = await asyncInstance.get("commmonallList");
      return response.data;
    } catch (error) {
      // toast.error("Something went wrong");
    }
  }
);
